/**
 * Mirrors packages/amgbaccarat_v2/lib/data/repositories/game_repository.dart
 * (kBaccaratGameKey / kBaccaratMultiplayerGameKey / kBaccaratHubUrl)
 * and core/constants/api_constants.dart.
 */
export const API_BASE = 'https://staginggameapi.tbgcablecar.xyz/api';

export const Endpoints = {
  login: `${API_BASE}/action/login`,
  openGame: `${API_BASE}/action/opengame`,
  checkBalance: `${API_BASE}/action/balance`,
  getInfo: `${API_BASE}/action/getinfo`,
  placeBet: `${API_BASE}/action/bet`,
  getHistory: `${API_BASE}/action/bethistory`,
} as const;

export const GAME_KEY_SINGLE = 'BKA1';
export const GAME_KEY_MULTI = 'BKAM';
export const MULTIPLAYER_HUB_URL =
  'https://staginggameapi.tbgcablecar.xyz/baccarathub';
export const DEFAULT_AGENT_ID = 'Agent1';

/** Reference stage size — mirrors apps/amg_baccarat_v2/web/index.html (UILayout). */
export const REF_WIDTH = 1792;
export const REF_HEIGHT = 828;

/**
 * Hard-coded test credentials — match the Flutter `LobbyScreen` defaults.
 * Source: apps/amg_baccarat_v2/lib/main.dart:78-86.
 */
export const DEFAULT_USER_NAME = 'user5';
export const DEFAULT_PASSWORD = '123456';

/** Default game config — used until /action/getinfo overrides. */
export const DEFAULT_GAME_CONFIG = {
  minBet: 1000,
  maxBet: 100000,
  chipValues: [1000, 5000, 10000, 50000, 100000, 500000] as const,
};
